import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/ApplyCredit.module.scss";
import {useTranslation} from "react-i18next";
import DashboardClass from "@/utils/dashboard_class";
import {useState, useEffect, useRef} from "react";
import CommonClass from "@/utils/common";
import {CircularProgress} from "@mui/material";
import {useNavigate} from "react-router-dom";
import useCalc from "@/hooks/calculator.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import ApplyForm from "@/pages/apply_credit/ApplyForm.tsx";
// import {useAtom} from "jotai/index";
// import {pending_loans} from "@/atoms/common.ts";
// import {profile} from "@/atoms/profile.ts";
// import {useAtom} from "jotai/index";
// import eventEmitter from "@/utils/event_emmiter_instance.ts";



const ApplyCreditForm = () => {
    
    const {t} = useTranslation()
    const [initBody, setBody] = useState<any>({})
    // const [user] = useAtom(profile)
    // const [loans] = useAtom(pending_loans)
    const calc = useCalc()
    const product = calc.get_product() as ProductInterface
    const effect_ran = useRef<any>(false)
    const navigate = useNavigate();
    let apply_form_body = sessionStorage.getItem(CommonClass.local_storage_fields.apply_credit_form_body)
    
    if(!apply_form_body) {
        apply_form_body = localStorage.getItem(CommonClass.local_storage_fields.reserve_data)
    }
    
    useEffect(() => {
        if (!effect_ran.current) {
            if (
                apply_form_body &&
                typeof JSON.parse(apply_form_body) === "object" &&
                Object.keys(JSON.parse(apply_form_body)).length
            ) {
                setBody(JSON.parse(apply_form_body))
            } else {
                navigate(DashboardClass.dashboard_routes.Home)
            }
        }
        
        const resetProducts = async () => {
            calc.product_handler(undefined)
            sessionStorage.removeItem(CommonClass.local_storage_fields.apply_credit_form_body)
            await calc.update_calculator_limits()
        }
        
        
        return () => {
            
            if(import.meta.env.MODE === 'development'){
                if(effect_ran.current) {
                    resetProducts()
                }
                
            } else {
                resetProducts()
                
            }
            effect_ran.current = true
        }
        
    }, []);
    
    
    useEffect(() => {
        
        if (typeof product === "object" && !Object.keys(product).length) {
            navigate(DashboardClass.dashboard_routes.Home)
        }
        
    }, [product]);
    
    
    return (
        <DashboardGenComponent
            
            header_type={"secondary"}
            responsive1
            // backFunction
            onBackClick={() => {
                
                const before = localStorage.getItem(CommonClass.local_storage_fields.before_apply_cr)
                
                sessionStorage.removeItem(CommonClass.local_storage_fields.apply_credit_form_body)

                if(before) {
                    navigate(before)
                    localStorage.removeItem(CommonClass.local_storage_fields.before_apply_cr)
                    
                } else {
                    navigate(DashboardClass.dashboard_routes.Home)
                    
                }

            }}
            
            heading={
                <div>
                    {t("apply_for_credit")}
                </div>
            }
            
            header_content={
                <div className={st.header_content}>
                    
                    {(typeof product === "object" && Object.keys(product)) ? (
                        <>
                            <div className={st.top}>
                                <strong>
                                    {t(initBody?.type) || ""}
                                </strong>
                                
                                {/*<span>*/}
                                {/*    {current_cr_type?.gaj}*/}
                                {/*</span>*/}
                            </div>
                            
                            <div className={st.center}>
                                <div>
                                    <span>
                                        {t("credit_amount")}
                                    </span>
                                    <strong>
                                        {CommonClass.formatMoneyAmount(product?.capital) || ""}
                                        {/*{CommonClass.formatMoneyAmount(Number(initBody?.amn))} */}
                                        {" " + t("currency")}
                                    </strong>
                                </div>
                                {initBody?.type !== "refinance" ? (
                                    <div>
                                        <span>
                                            {t("monthly_payment")}
                                        </span>
                                        
                                        <strong>
                                            {CommonClass.formatMoneyAmount(product?.installment_amount) || ""}
                                            {/*{CommonClass.formatMoneyAmount(initBody?.monthlyPay)} */}
                                            {" " + t("currency")}
                                        </strong>
                                    </div>
                                ) : null}
                                
                                
                                {/*<div></div>*/}
                            </div>
                            
                            <div className={st.bottom}>
                                <div>
                                    <span>
                                        {t("period")}
                                    </span>
                                    
                                    <strong>
                                        {product?.months || ""} {t("months")}
                                    </strong>
                                </div>
                                
                                <div>
                                    <span>
                                        {t("credit_end")}
                                    </span>
                                    
                                    <strong>
                                        {CommonClass.date_plus_months(product?.months) || ""}
                                    </strong>
                                </div>
                                
                                {/*<div>*/}
                                {/*    <span>*/}
                                {/*        {t("yearly_rate")}*/}
                                {/*    </span>*/}
                                {/*    /!*TODO : take care of percentage, needs to change*!/*/}
                                {/*    <strong>*/}
                                {/*        {product?.interest_rate || 0}%*/}
                                {/*    </strong>*/}
                                {/*</div>*/}
                            </div>
                        </>
                    ) : (
                        <CircularProgress
                            sx={{
                                display: "block",
                                margin: "0 auto",
                                color: "#000",
                            }}
                        />
                    )}
                
                </div>
            }
            
            column_center={
                <div className={st.column_center}>
                    <ApplyForm product={product} initBody={initBody} />
                </div>
            }
        
        />
    )
}





export default ApplyCreditForm